import { m } from "../../paraglide/messages";

import { AnalyticCard } from "./AnalyticCard";

export function MetricCardError({
  title,
  tooltip,
}: {
  title: string;
  tooltip?: string;
}) {
  return (
    <AnalyticCard
      dataTestId="metric-card-error"
      title={title}
      titleJustifyBetween={false}
      tooltip={tooltip}
      variant="compact"
    >
      <div className="flex flex-col gap-0 justify-between items-start w-full h-full min-w-0">
        <div className="flex flex-col gap-0 w-full min-w-0">
          <p className="heading-4 text-error text-text/secondary truncate w-full">
            -
          </p>
        </div>
        <div className="flex gap-1 items-center pt-4 body-small-regular text-text/disabled truncate w-full">
          {m.analytics_error_dataTemporarilyUnavailable()}
        </div>
      </div>
    </AnalyticCard>
  );
}
